import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Promocode } from "@modules/promocodes/types";
import { PromocodeFormValues } from "@modules/promocodes/validations";

import { editPromocodeService } from "./service";
import { UseEditPromocodeMutationOptions } from "./types";

export function useEditPromocodeMutation(
  options?: UseEditPromocodeMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Promocode, ApiError, { id: string; data: PromocodeFormValues }>({
    mutationFn: ({ id, data }) => editPromocodeService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("promocode_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
